import { Outlet } from "react-router-dom";
import { SiteFooter } from "./SiteFooter";
import { SiteHeader } from "./SiteHeader";
import { StoreLocatorBar } from "./StoreLocatorBar";

export function SiteLayout() {
  return (
    <div id="site-layout" className="kmart-page">
      <SiteHeader />
      <StoreLocatorBar />
      <main id="main-content">
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  );
}
